import { Networks as NetworksEnumProxy } from '@iotv/iotv-v3-types';
export const getValidation = (context) => {
    const { Areas, Places, Networks, Gateways, parameters: { distanceFromPointMeters, timePeriod }, bounds, } = context;
    const areasPlacesValid = [...Areas, ...Places].length > 0;
    const gatewaysValid = true;
    const networksValid = Networks.length === 0 || Networks.every((nw) => nw);
    const paramsValidation = {
        valid: true,
        msg: undefined,
    };
    if (!distanceFromPointMeters) {
        paramsValidation.valid = false;
        paramsValidation.msg = 'Distance from place must be specified.';
    }
    if (!timePeriod?.fromDateMs) {
        paramsValidation.valid = false;
        paramsValidation.msg = (paramsValidation.msg ?? ' ') + 'From time must be specified.';
    }
    if (!timePeriod?.toDateMs) {
        paramsValidation.valid = false;
        paramsValidation.msg = (paramsValidation.msg ?? ' ') + 'To time must be specified.';
    }
    return {
        AreasPlaces: { valid: areasPlacesValid, msg: areasPlacesValid ? undefined : `One or more Area or Place needs to be specified.` },
        Gateways: { valid: gatewaysValid, msg: gatewaysValid ? undefined : `One or more Gateway needs to be defined.` },
        Network: { valid: networksValid, msg: networksValid ? undefined : `Network needs to be one of ${Object.keys(NetworksEnumProxy).join(', ')}.` },
        Params: paramsValidation,
        Bounds: { valid: !!bounds, msg: !!bounds ? undefined : `No bounds are set.` },
    };
};
/** returns true when all fields are populated and context can be used as coverage request */
export const isValidContext = (validationMap) => {
    return Object.entries(validationMap).reduce((a, [k, v]) => a && v.valid, true);
};
export const getValidationMessage = (validationMap) => {
    return Object.entries(validationMap)
        .map(([k, v]) => v.msg)
        .join(' ');
};
